import { Component, OnInit } from '@angular/core';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { fuseAnimations } from '@fuse/animations';
import Swal from 'sweetalert2';

/// LISTADO DE PASOS DE WIZARD DE CADA PRODUCTO
import { est1_steps } from './est-1/est-1.steps';

///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'culture-audit',
  templateUrl: './culture-audit.component.html',
  styleUrls: ['./culture-audit.component.scss'],
  animations   : fuseAnimations
})
export class CultureAuditComponent implements OnInit {

  animationDirection: 'left' | 'right' | 'none';
  currentStep: number;
  lastStep: number;
  iconoStep: any = {
    undone: 'lock',
    pending: 'more_horiz',
    done: 'done'
  };

  pasosWizard: any;

  stpAllOk = false;

  demos = [1,1,1,1,1,1,1,1,1,1,1];

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _fuseSidebarService: FuseSidebarService,
    private translateSrv: TranslateService
  ) {
    this.animationDirection = 'none';
    this.currentStep = 0;
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.colocaPasos();
  }

  colocaPasos(){
    this.pasosWizard = est1_steps;
    this.stpAllOk = true;
  }

  aletaRestric(opc:number){
      let texto: string;
      switch(opc){
        case 1: case 2: case 3: case 4: case 5: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest1'; break;
        case 6: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest5'; break;
        case 7: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest2'; break;
        case 8: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest3'; break;
        case 9: texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.RESTRICCIONES.rest4'; break;
      }

      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      Swal.fire({
        html: texto,
        icon: 'error',
        confirmButtonColor: '#e40601'
      });
  }

  gotoStep(step): void
  {
      this.animationDirection = this.currentStep < step ? 'left' : 'right';
      //this._changeDetectorRef.detectChanges();

      this.lastStep = this.currentStep;

      this.currentStep = step;
  }

  toggleSidebar(name): void
  {
      this._fuseSidebarService.getSidebar(name).toggleOpen();
  }

}
